import { render, staticRenderFns } from "./ColumnName.vue?vue&type=template&id=4d2997d4&scoped=true&"
import script from "./ColumnName.vue?vue&type=script&lang=js&"
export * from "./ColumnName.vue?vue&type=script&lang=js&"
import style0 from "./ColumnName.vue?vue&type=style&index=0&id=4d2997d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d2997d4",
  null
  
)

export default component.exports